import {
  Component, Input, Output, EventEmitter, OnInit,
  AfterViewInit, AfterViewChecked,  ElementRef
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';

import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';


@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss']

})
export class AlertModalComponent implements OnInit {

  @Input() showModal: boolean;
  @Input() content: string;
  @Input() triggerElement: any;

  @Output()
  modalOutput: EventEmitter<boolean>;

  focusabbleElements: any;

  constructor( private el: ElementRef) {
    this.modalOutput = new EventEmitter<boolean>();
    this.showModal = false;
  }

  ngOnInit() {
    document.body.classList.add('modal-open');
  }

  btnAction() {
    document.body.classList.remove('modal-open');
    this.focusabbleElements = undefined;
    if (this.triggerElement) {
      this.triggerElement.focus();
    }
    this.modalOutput.emit(false);
  }


  handleKeydown(event) {
    const focussedEl = event.target;
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.btnAction();
      return;
    }
    if (event.keyCode === KEY_CONFIG.tabKey) {
      if (focussedEl === this.focusabbleElements[this.focusabbleElements.length - 1]) {
        event.preventDefault();
        this.focusabbleElements[0].focus();
      }
    }
  }

    loadFocustelements() {
    if (!this.focusabbleElements) {
      const focusableEls = this.el.nativeElement.
        querySelectorAll('a[href], area[href],' +
        ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
      this.focusabbleElements = Array.prototype.slice.call(focusableEls);
      this.focusabbleElements[0].focus();
    }
  }

}
